// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPickDownloadHero-cls1_9Kj","cls2":"LoswpPickDownloadHero-cls2_gvG LoswpPickDownloadHero-cls1_9Kj"};